import { call, delay, put, select, takeLatest } from 'redux-saga/effects';

import { CLIENTS_EDIT, APP } from 'src/store/ActionTypes';
import * as api from 'src/store/api';

function* fetchOnboardingConfigsL1(action) {
  try {
    const configs = yield call(api.fetchOnboardingConfigs, action.payload);
    yield put({
      type: CLIENTS_EDIT.FETCH_ONB_CONFIGS_L1_SUCCEEDED,
      payload: configs,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.FETCH_ONB_CONFIGS_L1_FAILED,
      payload: e.message,
    });
  }
}

function* fetchOnboardingConfigsL2(action) {
  try {
    const configs = yield call(api.fetchOnboardingConfigs, action.payload);
    yield put({
      type: CLIENTS_EDIT.FETCH_ONB_CONFIGS_L2_SUCCEEDED,
      payload: configs,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.FETCH_ONB_CONFIGS_L2_FAILED,
      payload: e.message,
    });
  }
}

function* fetchOnboardingConfigsL3(action) {
  try {
    const configs = yield call(api.fetchOnboardingConfigs, action.payload);
    yield put({
      type: CLIENTS_EDIT.FETCH_ONB_CONFIGS_L3_SUCCEEDED,
      payload: configs,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.FETCH_ONB_CONFIGS_L3_FAILED,
      payload: e.message,
    });
  }
}

function* fetchOnboardingConfigTypes(action) {
  try {
    const configTypes = yield call(api.fetchOnboardingConfigTypes, action.payload);
    yield put({
      type: CLIENTS_EDIT.FETCH_ONB_CONFIG_TYPES_SUCCEEDED,
      payload: configTypes,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.FETCH_ONB_CONFIG_TYPES_FAILED,
      payload: e.message,
    });
  }
}

function* fetchClientOnboardingConfig(action) {
  try {
    const { type, scopeClientType, tenant } = action.payload;
    const config = yield call(api.fetchClientOnboardingConfig, type, scopeClientType, tenant);
    yield put({
      type: CLIENTS_EDIT.FETCH_CLIENT_ONB_CONFIG_SUCCEEDED,
      payload: config,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.FETCH_CLIENT_ONB_CONFIG_FAILED,
      payload: e.message,
    });
  }
}

function* fetchClient(action) {
  try {
    const client = yield call(api.getClient, action.payload);
    yield put({
      type: CLIENTS_EDIT.FETCH_CLIENT_SUCCEEDED,
      payload: client,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.FETCH_CLIENT_FAILED,
      payload: e.message,
    });
  }
}

function* enableRealTimeApi(action) {
  try {
    yield call(api.enableRealTimeApi, action.payload);
    yield put({
      type: CLIENTS_EDIT.ENABLE_REAL_TIME_API_SUCCEEDED,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.ENABLE_REAL_TIME_API_FAILED,
    });
  } finally {
    delay(500);
    yield put({
      type: CLIENTS_EDIT.UNSET,
      payload: 'enableRealTimeApiStatus',
    });
  }
}

function* disableRealTimeApi(action) {
  try {
    yield call(api.disableRealTimeApi, action.payload);
    yield put({
      type: CLIENTS_EDIT.DISABLE_REAL_TIME_API_SUCCEEDED,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.DISABLE_REAL_TIME_API_FAILED,
    });
  } finally {
    delay(500);
    yield put({
      type: CLIENTS_EDIT.UNSET,
      payload: 'disableRealTimeApiStatus',
    });
  }
}

function* editClient(action) {
  try {
    const { clientId, client } = action.payload;
    yield call(api.editClient, clientId, client);
    yield put({
      type: CLIENTS_EDIT.EDIT_CLIENT_SUCCEEDED,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.EDIT_CLIENT_FAILED,
      payload: e.message,
    });
  } finally {
    delay(500);
    yield put({
      type: CLIENTS_EDIT.UNSET,
      payload: 'editClientStatus',
    });
  }
}

function* editOnboardingConfig(action) {
  try {
    const { id, onboardingConfig } = action.payload;
    yield call(api.updateOnboardingConfig, id, onboardingConfig);
    yield put({
      type: CLIENTS_EDIT.EDIT_ONB_CONFIG_SUCCEEDED,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.EDIT_ONB_CONFIG_FAILED,
      payload: e.message,
    });
  } finally {
    delay(500);
    yield put({
      type: CLIENTS_EDIT.UNSET,
      payload: 'editOnboardingConfigStatus',
    });
  }
}

function* addOnboardingConfig(action) {
  try {
    yield call(api.addOnboardingConfig, action.payload);
    yield put({
      type: CLIENTS_EDIT.ADD_ONB_CONFIG_SUCCEEDED,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.ADD_ONB_CONFIG_FAILED,
      payload: e.message,
    });
  } finally {
    delay(500);
    yield put({
      type: CLIENTS_EDIT.UNSET,
      payload: 'addOnboardingConfigStatus',
    });
  }
}

function* fetchPossibleSubscribers(action) {
  try {
    const lastCmd = yield select((state) => state?.clientsEdit?.lastCmd);
    let users;
    if (lastCmd === 'add') {
      users = yield select((state) => state?.clientsEdit?.possibleSubscribers);
    } else {
      users = yield call(api.fetchPossibleClSubs);
    }
    const subscribedEmail = (yield select((state) => state?.clientsEdit?.subscribed)).map((sub) => sub.email);

    yield put({
      type: CLIENTS_EDIT.FETCH_POSSIBLE_SUBSCRIBERS_SUCCEEDED,
      payload: users
        .filter((user) => !subscribedEmail.includes(user.email))
        .sort((a, b) => {
          const emailA = a.email.toUpperCase();
          const emailB = b.email.toUpperCase();
          if (emailA < emailB) return -1;
          if (emailA > emailB) return 1;
          return 0;
        }),
    });
  } catch (err) {
    yield put({
      type: CLIENTS_EDIT.FETCH_POSSIBLE_SUBSCRIBERS_SUCCEEDED,
      payload: err.toString(),
    });
  }
}

function* fetchSubscribed(action) {
  try {
    const {
      payload: { fields = '*', ...query },
    } = action;
    const options = {
      headers: {
        'X-Fields': fields,
      },
    };
    const subscribed = yield call(api.fetchSubscribed, query, options);
    const finalSubscribers = [];
    for (const sub of subscribed) {
      const { email, username } = yield call(api.getUser, sub.subscriberId);
      finalSubscribers.push({ ...sub, info: { email, username } });
    }
    yield put({
      type: CLIENTS_EDIT.FETCH_SUBSCRIBED_SUCCEEDED,
      payload: finalSubscribers.sort((a, b) => {
        const emailA = a.info.email.toUpperCase();
        const emailB = b.info.email.toUpperCase();
        if (emailA < emailB) return -1;
        if (emailA > emailB) return 1;
        return 0;
      }),
    });
  } catch (err) {
    yield put({
      type: CLIENTS_EDIT.FETCH_SUBSCRIBED_FAILED,
      payload: err.toString(),
    });
  }
}

function* updateSubscribed(action) {
  try {
    const { cmd, ...rest } = action.payload;
    if (cmd === 'add') {
      yield call(api.addSubscriber, rest);
      yield put({
        type: APP.ENQUEUE_NOTIFICATION,
        payload: {
          message: 'Added subscriber',
          options: { autoClose: true },
        },
      });
    } else if (cmd === 'del') {
      yield call(api.delSubscriber, rest.id);
      yield put({
        type: APP.ENQUEUE_NOTIFICATION,
        payload: {
          message: 'Deleted subscriber',
          options: { autoClose: true },
        },
      });
    }
    yield put({
      type: CLIENTS_EDIT.UPDATE_SUBSCRIBED_SUCCEEDED,
      payload: cmd,
    });
  } catch (err) {
    yield put({
      type: CLIENTS_EDIT.UPDATE_SUBSCRIBED_FAILED,
      payload: err.toString(),
    });
  } finally {
    yield delay(250);
    yield put({
      type: CLIENTS_EDIT.UNSET,
      payload: 'updateSubscribedStatus',
    });
  }
}

function* fetchOnboardingConfigsL1Saga() {
  yield takeLatest(CLIENTS_EDIT.FETCH_ONB_CONFIGS_L1, fetchOnboardingConfigsL1);
}

function* fetchOnboardingConfigsL2Saga() {
  yield takeLatest(CLIENTS_EDIT.FETCH_ONB_CONFIGS_L2, fetchOnboardingConfigsL2);
}

function* fetchOnboardingConfigsL3Saga() {
  yield takeLatest(CLIENTS_EDIT.FETCH_ONB_CONFIGS_L3, fetchOnboardingConfigsL3);
}

function* fetchOnboardingConfigTypesSaga() {
  yield takeLatest(CLIENTS_EDIT.FETCH_ONB_CONFIG_TYPES, fetchOnboardingConfigTypes);
}

function* fetchClientOnboardingConfigSaga() {
  yield takeLatest(CLIENTS_EDIT.FETCH_CLIENT_ONB_CONFIG, fetchClientOnboardingConfig);
}

function* fetchClientSaga() {
  yield takeLatest(CLIENTS_EDIT.FETCH_CLIENT, fetchClient);
}

function* editClientSaga() {
  yield takeLatest(CLIENTS_EDIT.EDIT_CLIENT, editClient);
}

function* editOnboardingConfigSaga() {
  yield takeLatest(CLIENTS_EDIT.EDIT_ONB_CONFIG, editOnboardingConfig);
}

function* addOnboardingConfigSaga() {
  yield takeLatest(CLIENTS_EDIT.ADD_ONB_CONFIG, addOnboardingConfig);
}

function* enableRealTimeApiSaga() {
  yield takeLatest(CLIENTS_EDIT.ENABLE_REAL_TIME_API, enableRealTimeApi);
}

function* disableRealTimeApiSaga() {
  yield takeLatest(CLIENTS_EDIT.DISABLE_REAL_TIME_API, disableRealTimeApi);
}

function* fetchPossibleSubscribersSaga() {
  yield takeLatest(CLIENTS_EDIT.FETCH_POSSIBLE_SUBSCRIBERS, fetchPossibleSubscribers);
}

function* fetchSubscribedSaga() {
  yield takeLatest(CLIENTS_EDIT.FETCH_SUBSCRIBED, fetchSubscribed);
}

function* updateSubscribedSaga() {
  yield takeLatest(CLIENTS_EDIT.UPDATE_SUBSCRIBED, updateSubscribed);
}

export default [
  fetchOnboardingConfigsL1Saga(),
  fetchOnboardingConfigsL2Saga(),
  fetchOnboardingConfigsL3Saga(),
  fetchOnboardingConfigTypesSaga(),
  fetchClientOnboardingConfigSaga(),
  fetchClientSaga(),
  editClientSaga(),
  fetchPossibleSubscribersSaga(),
  fetchSubscribedSaga(),
  updateSubscribedSaga(),
  editOnboardingConfigSaga(),
  addOnboardingConfigSaga(),
  enableRealTimeApiSaga(),
  disableRealTimeApiSaga(),
];
